module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("I")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("The Offer")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("People packed the auditorium. Every seat was filled and more listeners crammed the aisles. An unspoken question charged the room: were today’s speakers revealing a spectacular new future for the human race or the end of humanity’s reign as the ruling species on Earth?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This session was a diamond in the crown of IRTAC, the International Robotics Technology and Applications Conference in the year 2021, held at Goddard Space Flight Center in Maryland. As chair of this session, Megan O’Flannery had chosen the speakers. She was sitting at a table on the right edge of the stage. At center stage, Arick Bjornsson had just finished his talk and now stood answering questions.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The genie is out of the bottle,” Arick was saying. “Our machines are intelligent. They won’t surpass us today or tomorrow, but it is only a matter of time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Listening to him, Megan pondered her own conflict. Her work on artificial intelligence for androids—humanlike robots—usually inspired her to look to the future with optimism. Sometimes, though, she wondered if they were only creating ways to magnify the human capacity for destruction. She would soon face a decision that forced her to confront the issue: could she use the fruits of her intellect to create machines meant to kill?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The scientists in the audience today came in all sizes, shapes, and ages. Most wore casual clothes: jeans, shirts or blouses, jumpsuits. The conference chair, a distinguished man in a well-cut suit, was sitting only few rows away from the stage. Several men and women sat with him, other high-ranking officials in suits or military uniforms. Megan recognized them all—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Except for the fellow on the right.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The stranger had dark eyes and tousled black hair. He looked more like a rebel than a scientist; his faded jeans had raveled at the knees, his denim shirt was frayed, and a black leather jacket with metal studs lay haphazardly over his legs. But the gold watch on his wrist caught the light with prismatic glints that suggested diamonds were embedded around its face. As he listened to the talk, emotions played across his features: skepticism, interest, outrage, amusement. He glared and crossed his arms at one point. Later, he relaxed and nodded with approval. The dramatic flair of his face intrigued Megan.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A woman sitting in front of the man suddenly swiped her hand past her face, undoubtedly bedeviled by one of the gnats that had infiltrated the auditorium. As she caught the bug, the man with the leather jacket reached forward and tapped her wrist. She turned with a jerk, reflexively opening her fist. The gnat flew out of her hand. The man said something, an apology it looked like, and sat back. She squinted at him, smiled uncertainly, and then turned back to the talk.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("That was odd,")]), _vm._v(" Megan thought. Interesting.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Arick finished and the audience applauded. After he took his seat, Megan went to the podium.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That concludes this session,” she said into the mic. “The media people tell me they’ll have copies of the proceedings online tomorrow. You can get them as holographs, in videos, or in memory cubes. A paper copy should be available in a few weeks.” She grinned at them, this collection of her colleagues, friends, and adversaries. “That’s it, folks. All we have left is the banquet. So let’s go eat and be merry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Laughter rippled through the audience, followed by a general murmur as people began talking, putting on coats, or seeking out one another to continue debates. Megan looked around for the man with the leather jacket, thinking to introduce herself, but he had disappeared.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("A long day, ")]), _vm._v("Megan thought as she left the auditorium in Building 3. Her hair was coming out of the knot on top her head, and red tendrils curled around her face. She pulled the misbehaving mass free, letting it fall in ripples to her waist. She needed to relax, but her workday hadn’t ended yet; she had one more meeting. An important one.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tired or not, she thrived on this life. Robots had fascinated her since her childhood in Bozeman, Montana. One of her earliest memories was toddling after a toy cat as it stalked around the spacious living room of her house. It hid behind a door, then tried to pounce on her. She had rocked with a small child’s laughter when it toppled in an undignified heap of fur, limbs, and blinking lights. She had spent the next hour taking out its batteries and trying to put them back.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("So she grew up and earned a B.S. in computer science at Montana State University, then a doctorate at Stanford. Now at thirty-five, she was an MIT professor. Some people called her driven, others called her single-minded. What they didn’t realize was that most of all, the delighted little girl still lived inside of her, marveling at her toys.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her enthusiasm bemused her mother, who had once asked, "), _c('i', [_vm._v("But Megan, why make robots that look like people? What’s wrong with the humans we already have?")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("It’s a new science, ")]), _vm._v("Megan answered. "), _c('i', [_vm._v("A new world, Mom. Maybe even a new species.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her mother had given her The Look then. Regarding Megan with the large blue eyes that her daughter had inherited, she had said, "), _c('i', [_vm._v("You know, dear, much more enjoyable ways exist to make new humans.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("All Megan had managed at the time was an aghast, "), _c('i', [_vm._v("Mom! ")]), _vm._v("One’s silver-haired mother wasn’t supposed to say such things, let alone look so pleased with herself, smiling like a cherub.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Megan supposed that if she would get married and make some new humans of the traditional kind, her mother would ease up on the subject. It wasn’t that Megan had no interest in the whole business; she just hadn’t found the right man. Although her parents had liked most of her past boyfriends, she always felt as if they were sizing up the poor fellows as potential grandchild-production sources.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A voice interrupted her reverie. A man and woman were approaching her along the sidewalk.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("So, ")]), _vm._v("Megan thought. "), _c('i', [_vm._v("This is it.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Dr. O’Flannery,” the man said as they came up to her. His styled haircut, expensive blue suit, and businesslike manner made a sharp contrast to the more informal clothes most scientists wore at the conference. The woman had gray hair and a piercing intelligence in her gaze. Megan recognized her, but she couldn’t remember from where.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The man extended his hand. “I’m Antonio Oreza. Tony.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Megan shook his hand. “Hello. Are you from MindSim?” She had agreed to meet their representatives after the session.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s right. I’m vice president in charge of research and development.” He indicated the woman with him. “This is Claire Oliana. She consults for us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("MindSim had sent a VP to talk to her? And "), _c('i', [_vm._v("Claire Oliana? ")]), _vm._v("The Stanford professor had received the Nobel Prize for work in physics that also included the development of machine intelligence.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Megan suddenly didn’t feel so tired anymore.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The new vending café in Building 3 had blue walls and tables covered by blue and white checked cloths. As Megan sat down with Tony and Claire, a vending robot bustled over, rolling on its treads. It stood about four feet tall, with a domed head and tubular body. The robot had a rudimentary AI limited to serving food. Its panels displayed cheerful holos of meals that looked far more delectable than anything Megan had actually eaten here.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Good afternoon,” it said. “I’m Jessie.” Its head swiveled from side to side as it surveyed them, giving the robot an earnest appearance. It made Megan smile, though she knew it was just mapping their positions with the cameras in its eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Do you have coffee?” Tony asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“A delicious menu to select from,” Jessie assured him. “French vanilla, cappuccino, Brazilian dry roast, decaf supreme, and today’s special, Martian bug-eyed-monster deluxe.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Megan laughed. “Monster deluxe? What is that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It has an unusually strong caffeine content,” Jessie said. “The night shift in the Science Operations Facility programmed it into me at four this morning. They required a strong restorative to continue functioning.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Claire smiled. “That much caffeine would send me into orbit. Decaf for me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“French vanilla here,” Tony said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Very wise choices,” Jessie said. A red cup plopped into a recess in its stomach and began filling with coffee.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll take the Martian deluxe,” Megan decided.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“As you wish.” If a machine could blink its lights with doubt over the wisdom of a customer’s choice, Jessie was doing it. Megan suspected the SOF night shift had also programmed some mischief into the droid’s personality.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After Jessie served their coffee, Tony clicked his money card into the robot. Jessie’s control panel sparkled as it spoke. “I hope you enjoy your meal.” Its head swiveled to Megan. “Please inform me if you need further assistance.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Megan couldn’t resist. “Like an ambulance?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The bot twinkled its lights. “I serve only the best food, ma’am.” It rolled away, playing a tinkling melody like the ice cream trucks in the neighborhood where she had grown up. At the far wall, it took up position and swiveled its head around, surveying the cafe like a carnival barker looking for new marks.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With a laugh, Claire said, “I think the night shift in the Science Operations Facility have been staying up too late.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Megan took a swallow of her drink. The stuff tasted like rocket fuel. “They know their coffee,” she said with approval.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tony was watching her. “I can’t help but wonder, Dr. O’Flannery, how you would program a robot like that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I don’t work with utility bots.” She had no doubt Tony knew exactly where her interests lay. With a smile she added, “And you should call me Megan.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Both Tony and Claire seemed pleased at this nonresponse. Tony leaned forward. “Megan, how would you feel about working with a functional android?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She resisted the urge to say "), _c('i', [_vm._v("Yes! ")]), _vm._v("If any corporation was advanced enough to have created a functional android, it was MindSim. But she had heard too many vague rumors lately about disasters in hidden projects at MindSim and elsewhere.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She kept her voice casual. “The problem is, no one has an android hanging around that wants a brain.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, no.” Tony beamed as if he were delivering great news. “However, MindSim has funding in that area.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Well, hey. ")]), _vm._v("Nowadays, everyone and her brother had funding in “that area.” Megan had researched MindSim after they invited her to this interview. They and their major competitor, Arizonix Corp, had both recently won Department of Defense grants for research into AI and androids. She’d probably need a security clearance, though, to hear details of those projects.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She chose a neutral response. “MindSim does good work.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tony spoke with polished enthusiasm. “We would like you to be part of our team.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Clair leaned forward. “Suppose you had the chance to lead such a project?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Megan barely kept from sputtering out her coffee."), _c('i', [_vm._v(" Hell, yes, she’d like that job. ")]), _vm._v("In fact, it sounded too good to be true. What had happened to the person who started the project? MindSim already had the DOD funds, so someone must have submitted a grant proposal as the principal investigator.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She said only, “It would depend on the circumstances.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Come out to MindSim and take a look,” Tony said. “We’ll show you around.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Huh. If she accepted that invitation, she was admitting to more than a passing interest in the job. She liked her position at MIT. She had grants, grad students, resources, colleagues, and a growing reputation in the field. The prestige didn’t hurt either.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But …")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She would give her right leg to work with a real android instead of running computer simulations. For that matter, if MindSim had designed a fully functioning android, she wouldn’t need her right leg anymore; she could make a new one. A visit wasn’t a commitment. If nothing else, an offer from MindSim might inspire MIT to give her a raise.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Megan leaned forward. “Let’s talk.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Goddard Space Flight Center covered many acres of land, with the rolling fields of the Beltsville Agricultural Center to the east and the Baltimore-Washington Parkway to the west. Stretches of forest separated the buildings, and deer wandered everywhere.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Lost in thought, Megan ambled down a back road. She had always enjoyed walking, and this gave her a chance to mull over the MindSim offer. A lake lay to her right, basking in the late afternoon sunlight. The day had that golden, antique quality that came late in the year. Ducks paddled in the water: speckled brown, gray, iridescent green, and the odd white goose with an orange beak. Farther down the shore, a man stood surrounded by birds. At first she wasn’t sure why they were squawking at him. Then she saw that he was scattering breadcrumbs for them to eat.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She was about to go another way when she recognized him: the intriguing fellow from the audience. He was taller than she had realized, over six feet it looked like. A gleaming jCube hung from his scuffed leather belt. He watched the enthused birds with a half-smile, as if he hadn’t decided whether or not it would insult their egos if he laughed at them.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Megan headed toward him. As she came closer, though, she hesitated. His muscular build and handsome face didn’t fit her image of a robotics expert. Black hair curled over his ears and down his neck, longer than men wore nowadays, but glossy with health. On most people, it would have looked sloppy; on him, it worked. The same was true of his clothes. What his long legs did for those raveling jeans would have brought their makers a fortune if they could have packaged the quality. It made her hang back, as if he were a holovid actor or someone similar that she would never meet in normal life.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He glanced up, straight at her. “Good afternoon, Dr. O’Flannery.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Uh, hi.” She couldn’t place his background. His face reminded her of pictures she had seen of the ancient Celts. His coloring looked Indian, as in India. His accent, like molasses on a summer afternoon, was undeniably from the American South.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“These ducks here are hungry.” He tossed the last of his bread into the lake. Flapping and squawking, the birds waddled after the morsels.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She laughed, self-conscious. “Greedy little birds.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Maybe.” He pointed at the sky. “They’re leaving.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She looked, as much to regain her composure as to see what he meant. A V-shape of birds was arrowing across the sky.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“So they are.” She turned back to him. For lack of anything better to say, she added, “Flying south for the winter, I imagine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He glanced at the birds still floating on the pond, and then held up his hand as if to offer them more delicacies. They paddled industriously toward him until they realized he was bluffing. Then they drifted off again. His gold watch glinted in the slanting rays of the sun.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“They don’t cheat,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m sure they don’t.” Megan had no idea what he was actually talking about, but she doubted it was birds. She could have listened to him talk all day in that gorgeous voice of his, deep and throaty, with a honeyed drawl.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Did you enjoy the session this afternoon?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I suppose.” "), _c('i', [_vm._v("Ah suhppose. ")]), _vm._v("“You should have given a talk. You do better work than the lot of them combined.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Thank you.” She paused. “I’m afraid I don’t know your name.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He considered her. “Call me Raj.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s your name?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, no. Yes. At times.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Raj isn’t your name?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“My mother calls me Robin.” He spread his hands as if to say, "), _c('i', [_vm._v("What can a person do?")])])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Megan could relate, given that her father still called her Maggie-kitten. She didn’t mind it from him, even liked it, but it would earn anyone else a shove into the lake. “What do other people call you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“All sorts of things.” He rubbed his ear. “I wouldn’t repeat most of them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She smiled. “So Raj is the name on your birth certificate.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She couldn’t help but laugh. “This is like pulling teeth.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His lips quirked up. “My birth certificate, from the fine state of Louisiana, says Chandrarajan.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She stared at him. “You’re "), _c('i', [_vm._v("Chandrarajan Sundaram?")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Please don’t look so shocked. I assure you, I’ve treated the name well.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Good Lord."), _c('i'), _vm._v("This was the reclusive eccentric who had revolutionized the robotics field? Unattached to any university or institute, he worked only as a consultant. Corporations paid him large amounts of money to solve their problems. Arizonix had supposedly given him several million after he fixed their disastrous household robot in time for its market release, saving the company from possible bankruptcy.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His reputation explained this strange conversation. Rumor claimed he paid a price for his phenomenal intellect; no one could think like him, but he had the devil of a time expressing those thoughts. From what she had heard, his mind didn’t work in linear thought processes, so he often made jumps of logic that few people could follow.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Megan had never expected him to show at her conference. She invited him, of course. He had been a top name on her hoped-for speakers list. But she had already known he never came to such meetings, so she wasn’t surprised when he declined.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Yet here he stood.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It’s actually Sundaram Chandrarajan Robert,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She blinked. “What?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“My name. It’s Sundaram Chandrarajan Robert.” He paused, then added, “My father followed the Indian custom of giving me his name, followed by a personal name for me. But that makes Robert my third name, which isn’t the custom here. We use Sundaram as our last name.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She wondered why the mention of his father caused his mood to turn quiet. “Where does the Robert come from?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“My mother’s side. She’s Irish.” He watched her with a long, considering look. “Then of course there are geese.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Birds again"), _c('i', [_vm._v(".")]), _vm._v(" She smiled, enjoying herself. “You know, I have no idea what we’re talking about.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The hint of a smile quirked his lips. “Most people don’t respond this way to me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What do they do?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Nod.” Wryly he added, “And then leave as fast as they can.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Is that what you want?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It depends.” He had all his attention focused on her. It was unsettling, like being scanned by a laser.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“On what?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Hair color.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This conversation was making less sense by the minute. It was fun, though. “Why hair color?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Red,” he said. “Yours is red.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, yes. My hair is definitely red.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Red flag.” He walked over to her. “For stop.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It took her a moment to realize he was making a joke. She thought he was also asking if she wanted him to get lost, though she couldn’t have said how she knew. Something about the way he looked at her. Given that he had come over as he spoke, she suspected he didn’t want to go. He reminded her of her father, an absented-minded architect who tended to talk in riddles when he was preoccupied.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She touched a tendril curling over her shoulder. “I’m sure my hair doesn’t say stop.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His grin was a brilliant flash of white teeth. “You’re quick.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Oh, Lord. ")]), _vm._v("It was fortunate this man lived as a recluse. Otherwise, womankind wouldn’t be safe from either his nutty conversation or his dazzling smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Not that quick.” Megan didn’t usually tell people she had no idea what they were talking about, but this was too engaging for her to care how she looked. “I still don’t get what you meant about the birds.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Winter is coming and they have a long way to go.” He motioned at a few scattered bread crumbs the ducks had missed. “Sure they eat a lot. But they aren’t greedy. They don’t cheat. They only take what they need.” His smile faded. “Humans could learn a lot from them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She wondered what sort of life he lived, that he saw the world in those terms. Then again, given the value of his intellect and personal wealth, people probably wanted whatever they could get from him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Perhaps we could,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“They followed me around too, you know,” he said. “I sent them away.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She squinted at him. “The birds?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No. The suits.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What suits?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“From MindSim.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ah. Tony and Claire. “They offered you a job?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes. I told them no.” Studying her face, he added, “But perhaps I will consult for them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her pulse jumped. Was he offering her the chance to work with him? Yes! She kept her voice calm, not wanting to seem too eager. “Maybe you should.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He offered his hand. “I’m pleased to have met you, Dr. O’Flannery.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She shook his hand. “Call me Megan.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Megan.” He nodded. Then he turned away and headed down the road. After a few steps, though, he turned back. “Oh. Yes. Good-bye, Megan.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She raised her hand. “Bye.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He nodded and went on his way, leaving her to wonder just what on Earth was happening at MindSim.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b97ae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section5.vue
// module id = 81
// module chunks = 0